import React from "react";
import "./recomndation.css";

import Viedos from "./Viedos";

function Recomndation() {
  return (
    <div className="reco">
      <div className="reco-viedos">
        <Viedos
          title="How to become a softwere Developer"
          timestamp="3 days ago"
          channelImage="https://wallpapercave.com/wp/mYad6P3.jpg"
          views="2.5M Views"
          channel="Sumit Thapa"
          image="https://wallpapercave.com/wp/mYad6P3.jpg"
        />

        <Viedos
          title="How to become a softwere Developer"
          timestamp="3 days ago"
          channelImage="https://wallpapercave.com/wp/mYad6P3.jpg"
          views="2.5M Views"
          channel="Sumit Thapa"
          image="https://th.bing.com/th/id/R.d15b456aba80c4a523cf1f6d31dce7e8?rik=2ZT%2baXLkZYcxWg&riu=http%3a%2f%2fthewowstyle.com%2fwp-content%2fuploads%2f2015%2f01%2fnature-wallpaper-27.jpg&ehk=jIVFSOxLN%2fQKs4hEfZHNWAeXoeXkeEXooP%2fTy9Vwkek%3d&risl=&pid=ImgRaw&r=0"
        />
        <Viedos
          title="How to become a softwere Developer"
          timestamp="3 days ago"
          channelImage="https://wallpapercave.com/wp/mYad6P3.jpg"
          views="2.5M Views"
          channel="Sumit Thapa"
          image="https://th.bing.com/th/id/R.8be5dd6f77aef628606b47ebaedd6d59?rik=Rkjbw1gS7WKoJQ&riu=http%3a%2f%2fwww.pixelstalk.net%2fwp-content%2fuploads%2f2016%2f06%2fFree-Download-HD-Nature-Wallpapers.jpg&ehk=tP8T8N0rpmVoV3YWAU2SjwqNgfaqTkiowaaNqg5X7A4%3d&risl=&pid=ImgRaw&r=0"
        />
        <Viedos
          title="How to become a softwere Developer"
          timestamp="3 days ago"
          channelImage="https://wallpapercave.com/wp/mYad6P3.jpg"
          views="2.5M Views"
          channel="Sumit Thapa"
          image="https://wallpapercave.com/wp/wp2599594.jpg"
        />
        <Viedos
          title="How to become a softwere Developer"
          timestamp="3 days ago"
          channelImage="https://wallpapercave.com/wp/mYad6P3.jpg"
          views="2.5M Views"
          channel="Sumit Thapa"
          image="https://i2.wp.com/www.electricbike.com/wp-content/uploads/2016/09/apex4.jpg?fit=1280%2C915&ssl=1"
        />
        <Viedos
          title="How to become a softwere Developer"
          timestamp="3 days ago"
          channelImage="https://wallpapercave.com/wp/mYad6P3.jpg"
          views="2.5M Views"
          channel="Sumit Thapa"
          image="https://3.bp.blogspot.com/-V4RwDp8Y_wA/T7pQzKlaMxI/AAAAAAAABBE/M6B94PF2jCs/s1600/world_top%2Bbike5.jpeg"
        />
        <Viedos
          title="How to become a softwere Developer"
          timestamp="3 days ago"
          channelImage="https://wallpapercave.com/wp/mYad6P3.jpg"
          views="2.5M Views"
          channel="Sumit Thapa"
          image="https://wallpapertag.com/wallpaper/full/f/e/d/507966-free-hd-movie-wallpapers-1080p-1920x1080.jpg"
        />
        <Viedos
          title="How to become a softwere Developer"
          timestamp="3 days ago"
          channelImage="https://wallpapercave.com/wp/mYad6P3.jpg"
          views="2.5M Views"
          channel="Sumit Thapa"
          image="https://wallup.net/wp-content/uploads/2016/03/09/50640-movies-Madagascar_movie.jpg"
        />
        <Viedos
          title="How to become a softwere Developer"
          timestamp="3 days ago"
          channelImage="https://wallpapercave.com/wp/mYad6P3.jpg"
          views="2.5M Views"
          channel="Sumit Thapa"
          image="https://s.studiobinder.com/wp-content/uploads/2019/11/jbareham_190421_0890_mcu_ranked_final.0.jpg"
        />
        <Viedos
          title="How to become a softwere Developer"
          timestamp="3 days ago"
          channelImage="https://wallpapercave.com/wp/mYad6P3.jpg"
          views="2.5M Views"
          channel="Sumit Thapa"
          image="https://hdqwalls.com/download/venom-movie-2018-hd-lf-1920x1080.jpg"
        />
        <Viedos
          title="How to become a softwere Developer"
          timestamp="3 days ago"
          channelImage="https://wallpapercave.com/wp/mYad6P3.jpg"
          views="2.5M Views"
          channel="Sumit Thapa"
          image="https://i0.wp.com/insessionfilm.com/wp-content/uploads/2018/04/Rampage-2018-after-credits-hq.jpg"
        />
        <Viedos
          title="How to become a softwere Developer"
          timestamp="3 days ago"
          channelImage="https://wallpapercave.com/wp/mYad6P3.jpg"
          views="2.5M Views"
          channel="Sumit Thapa"
          image="https://www.allhorror.com/public/uploads/2020/03/gT93AfTce0KFUjMTCyKfZ8Pd2MJ.jpg"
        />
        <Viedos
          title="How to become a softwere Developer"
          timestamp="3 days ago"
          channelImage="https://wallpapercave.com/wp/mYad6P3.jpg"
          views="2.5M Views"
          channel="Sumit Thapa"
          image="https://i.ytimg.com/vi/9LkX7tE4Gxw/maxresdefault.jpg"
        />
        <Viedos
          title="How to become a softwere Developer"
          timestamp="3 days ago"
          channelImage="https://wallpapercave.com/wp/mYad6P3.jpg"
          views="2.5M Views"
          channel="Sumit Thapa"
          image="https://d2rd7etdn93tqb.cloudfront.net/wp-content/uploads/2017/05/footloose-remake-movie-still-051817.jpg"
        />
      </div>
    </div>
  );
}

export default Recomndation;
